"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSizeAwareComponent = exports.SizeProvider = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = __importDefault(require("react"));
// @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
const SizeContext = react_1.default.createContext();
exports.SizeProvider = SizeContext.Provider;
const getSizeAwareComponent = Component => (props) => (0, jsx_runtime_1.jsx)(SizeContext.Consumer, { children: size => (0, jsx_runtime_1.jsx)(Component, Object.assign({}, props, { size: size })) });
exports.getSizeAwareComponent = getSizeAwareComponent;
